import React from 'react';
import { Card } from '../ui/Card';
import { Building2, ShoppingBag, Globe2, Users } from 'lucide-react';
export function UseCases() {
  const cases = [{
    title: 'Fintechs & PSPs',
    description: 'Embed global accounts and FX into your product.',
    icon: Building2
  }, {
    title: 'Marketplaces & Platforms',
    description: 'Automate payouts to sellers in 100+ currencies.',
    icon: ShoppingBag
  }, {
    title: 'Enterprises',
    description: 'Optimize treasury and manage cross-border liquidity.',
    icon: Globe2
  }, {
    title: 'Cross-border Payroll',
    description: 'Pay remote teams and suppliers instantly.',
    icon: Users
  }];
  return <section className="py-24 bg-white" data-id="element-750">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-751">
        <div className="mb-12 sm:mb-16 text-center sm:text-left" data-id="element-752">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-753">
            Built for scale
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto sm:mx-0" data-id="element-754">
            Powering the next generation of global financial applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-755">
          {cases.map(item => <Card key={item.title} className="bg-slate-50 border-transparent hover:bg-white hover:border-slate-200 transition-all text-center sm:text-left flex flex-col items-center sm:items-start" data-id="element-756">
              <item.icon className="w-8 h-8 text-slate-900 mb-6" data-id="element-757" />
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-758">
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm" data-id="element-759">{item.description}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}